import styled from 'styled-components'

const LearningPlanTagStyled = styled.div`
  display: flex;
  gap: .25rem;
  margin-block-end: .25rem;
  .tag {
    font-weight: 700;
    font-size: 10px;
    line-height: 16px;
    color: var(--neutral110);
    border-radius: .25rem;
    padding: 0 .25rem;
  }
  .course-tag {
    background: var(--turquoise);
  }
  .project-tag {
    background: #20FF2C;
  }
  .workshop-tag {
    background: #6A2EFF;
    color: var(--white);
  }
  .free-tag {
    color: var(--white);
    background: var(--secondary);
  }
  .basic-tag {
    color: var(--white);
    background: #2222FC;
  }
  .intermediate-tag {
    background: #FA00FF;
  }
  .advanced-tag {
    background: #FF5B27;
  }
  .challenge-tag {
    background: #20FF2C;
  }
  .coming-soon-tag {
    color: var(--white);
    background: #ff5722;
  }
`

function LearningPlanTag({
  free, workshop, project, level, challenge, notShow, comingSoon,
}) {
  return (
    <LearningPlanTagStyled>
      {challenge ? (
        <span className="tag challenge-tag">Reto</span>
      ) : null}
      {level === 'BASIC' ? (
        <span className="tag basic-tag">Básico</span>
      ) : null}
      {level === 'INTERMEDIATE' ? (
        <span className="tag intermediate-tag">Intermedio</span>
      ) : null}
      {level === 'ADVANCED' ? (
        <span className="tag advanced-tag">Avanzado</span>
      ) : null}
      {!workshop && !project && !notShow && (
        <span className="tag course-tag">Curso</span>
      )}
      {project ? (
        <span className="tag project-tag">Proyecto</span>
      ) : null}
      {workshop ? (
        <span className="tag workshop-tag">Taller</span>
      ) : null}
      {free ? (
        <span className="tag free-tag">Gratis</span>
      ) : null}
      {comingSoon ? (
        <span className="tag coming-soon-tag">Proximamente</span>
      ) : null}
    </LearningPlanTagStyled>
  )
}

export default LearningPlanTag
